<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-on="{ ...on, ...attrs }">mdi-dots-vertical</v-icon>
      </template>

      <v-list>
        <v-list-item @click="clickedMenuItem('new-student-schedule')">
          <v-list-item-title>New Student Schedule</v-list-item-title>
        </v-list-item>
        <v-list-item @click="clickedMenuItem('new-teacher-schedule')">
          <v-list-item-title>New Teacher Schedule</v-list-item-title>
        </v-list-item>
        <v-list-item @click="clickedMenuItem('new-teacher-availability')">
          <v-list-item-title>New Teacher Availability</v-list-item-title>
        </v-list-item>
        <v-list-item
          :disabled="true"
          @click="clickedMenuItem('email-teacher-schedule')"
        >
          <v-list-item-title>Email Schedule</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import {
  openNewStudentSchedule,
  openNewTeacherAvailability,
  openNewTeacherSchedule,
} from "./eventHandler.js";
import moment from "moment";

export default {
  props: {
    dateRange: {
      type: Object,
      required: false,
    },
    rowItem: {
      type: Object,
      required: false,
    },
    teachers: {
      type: Array,
      required: false,
    },
    classrooms: {
      type: Array,
      required: false,
    },
  },
  computed: {
    startDate() {
      return this.dateRange
        ? moment(this.dateRange.start).format("YYYY-MM-DD")
        : null;
    },
    endDate() {
      return this.dateRange
        ? moment(this.dateRange.end).format("YYYY-MM-DD")
        : null;
    },
  },
  methods: {
    clickedMenuItem(menu) {
      const row = this.rowItem.row;
      const classroom =
        row && row.groupType == "classroom" && row.entityId
          ? row.entityId
          : null;
      const teacher =
        row && row.groupType == "teacher" && row.entityId
          ? {
              id: row.entityId,
              name: row.name,
              firstName: row.teacherFirstName,
              lastName: row.teacherLastName,
            }
          : null;

      switch (menu) {
        case "new-student-schedule":
          openNewStudentSchedule({ classroom, teacher });
          break;
        case "new-teacher-schedule":
          openNewTeacherSchedule({ classroom, teacher });
          break;
        case "new-teacher-availability":
          openNewTeacherAvailability({ teacher });
          break;
      }
    },
    openNewPage(routeObj) {
      const { name, params } = routeObj;
      const route = this.$router.resolve({ name, params });
      const url = route.href + "?" + this.serializeParams(params);
      window.open(url, "_blank");
    },
    serializeParams(params) {
      const encodedParams = Object.keys(params)
        .map(
          (key) =>
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
        )
        .join("&");
      return encodedParams;
    },
  },
};
</script>
